import { ConsumptionAttributeType } from '../model';

export class AttributeMissingError extends Error {
  public constructor(attribute: ConsumptionAttributeType) {
    super(`Attribute "${attribute}" value is missing`);
  }
}
